/**
 * Utility functions for managing application data
 */

/**
 * Clear all application data stored in localStorage
 * This function removes all design-related data from browser storage
 */
export const clearLocalStorageData = () => {
  console.log('🧹 Clearing localStorage data...');
  
  try {
    const keysToRemove = [];
    
    // Collect all keys that look like design data
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        // Remove design-related keys (typically uppercase product keys with underscores)
        // Examples: "POKERSET_EDGED_WHITE_BOX", "SA_FRONT_BLACK", etc.
        if (key.includes('_') || key.match(/^[A-Z0-9]+$/)) {
          keysToRemove.push(key);
        }
      }
    }
    
    // Remove the collected keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      console.log(`✅ Removed localStorage key: ${key}`);
    });
    
    console.log(`🎉 Cleared ${keysToRemove.length} items from localStorage`);
    
    return {
      success: true,
      clearedCount: keysToRemove.length,
      clearedKeys: keysToRemove
    };
    
  } catch (error) {
    console.error('❌ Error clearing localStorage:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Clear all localStorage data (complete wipe)
 * Use with caution - this removes ALL localStorage data
 */
export const clearAllLocalStorage = () => {
  console.log('🧹 Clearing ALL localStorage data...');
  
  try {
    const itemCount = localStorage.length;
    localStorage.clear();
    console.log(`🎉 Cleared all ${itemCount} items from localStorage`);
    
    return {
      success: true,
      clearedCount: itemCount
    };
    
  } catch (error) {
    console.error('❌ Error clearing all localStorage:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Get information about localStorage usage
 */
export const getLocalStorageInfo = () => {
  const info = {
    totalKeys: localStorage.length,
    designKeys: [],
    otherKeys: []
  };
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) {
      if (key.includes('_') || key.match(/^[A-Z0-9]+$/)) {
        info.designKeys.push(key);
      } else {
        info.otherKeys.push(key);
      }
    }
  }
  
  return info;
};
